import React from 'react';

import { Text } from '~/components/core';
import IconButton from '~/components/core/Atomic/Buttons/IconButton';
import ColoredDot from '~/components/core/Atomic/ColoredDot';
import type { DndDragHandleProps } from '~/components/core/DndOrderedList/DndOrderedList.types';
import { PencilIcon } from '~/components/icons';
import OverflowTextWithToolTip from '~/components/OverflowTextWithToolTip';
import ReorderDragHandle from '~/components/SystemConfiguration/FnolConfiguration/FnolConfigurationScreen/components/ReorderDragHandle';
import Switch from '~/components/ui/atoms/Switch';
import type { ClaimStageConfigurationModel } from '~/server_shared/openapi/data-contracts';

import { STAGE_ROW_GRID } from '../constants';
import TEXTS from '../texts';

type StageConfigRowProps = {
  stage: ClaimStageConfigurationModel;
  dragHandleProps: DndDragHandleProps;
  onToggle: () => void;
  onEdit: () => void;
  disabled: boolean;
};

const StageConfigRow = ({ stage, dragHandleProps, onToggle, onEdit, disabled }: StageConfigRowProps) => {
  const { key, label, color, is_enabled, is_initial } = stage;

  return (
    <div className={`${STAGE_ROW_GRID} rounded-lg bg-slate-200 px-8 py-12`}>
      <ReorderDragHandle dragHandleProps={dragHandleProps} disabled={disabled} iconSize={24} />
      <ColoredDot color={color} />
      <div className="flex min-w-0 flex-col">
        <OverflowTextWithToolTip tooltipTitle={key}>
          <Text variant={Text.VARIANTS.SM} className="inline">
            {key}
          </Text>
        </OverflowTextWithToolTip>
        {is_initial && (
          <Text variant={Text.VARIANTS.XXS} colorVariant={Text.COLOR_VARIANTS.SECONDARY}>
            {TEXTS.initial}
          </Text>
        )}
      </div>
      <OverflowTextWithToolTip tooltipTitle={label}>
        <Text variant={Text.VARIANTS.SM} weight="semi-bold" className="inline">
          {label}
        </Text>
      </OverflowTextWithToolTip>
      <Switch
        checked={is_enabled}
        onChange={onToggle}
        disabled={disabled}
        aria-label={`${TEXTS.columns.enabled} — ${label}`}
        className="justify-self-end"
      />
      <IconButton onClick={onEdit} disabled={disabled} aria-label={TEXTS.editStage} className="justify-self-end">
        <PencilIcon />
      </IconButton>
    </div>
  );
};

export default StageConfigRow;
